import React, { FC } from 'react';
import { RedirectWithParams, useRegistrationFlow } from '../../auth';
import {
    hasError,
    isLoading,
    notInitiated,
    RegistrationLoadingPlaceholder,
    useOidcAuthentication,
} from '@cp-shared-19/frontend-ui';
import {
    connectionProblemPagePath,
    dashboardPagePath,
    identificationPagePath,
} from '../../components/navigation/paths';
import { Redirect } from 'react-router-dom';

export const LoginInProgressPage: FC = () => {
    const { state: registrationState, initiate: initiateRegistration } = useRegistrationFlow();
    const { isAuthenticated, isLoading: isLoadingAuth, error } = useOidcAuthentication();

    if (isLoadingAuth) {
        return <RegistrationLoadingPlaceholder />;
    }

    if (notInitiated(registrationState) && isAuthenticated) {
        initiateRegistration();
        return <RegistrationLoadingPlaceholder />;
    }

    if (hasError(registrationState) || error) {
        return <RedirectWithParams to={connectionProblemPagePath()} />;
    }

    if (isLoading(registrationState)) {
        return <RegistrationLoadingPlaceholder />;
    }

    if (!(registrationState as { isAuthorized: boolean }).isAuthorized) {
        return <Redirect to={identificationPagePath()} />;
    }

    return <Redirect to={dashboardPagePath()} />;
};
